"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorNestedList = exports.CSS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const image_button_1 = require("../../../components/button/image.button");
const icons_1 = require("../../../components/icon/icons");
const input_1 = require("../../../components/input/input");
const input_state_1 = require("../../../components/input/input.state");
const input_state_group_1 = require("../../../components/input/input.state.group");
const modal_service_1 = require("../../../components/modal/modal.service");
const theme_1 = require("../../../components/theme");
const theme_util_1 = require("../../../components/theme.util");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const form_field_editor_1 = require("./form.field.editor");
exports.CSS = {
    container: 'c-FdcNestedList',
    list: 'c-FdcNestedList__list',
    option: 'c-FdcNestedList__option',
    value: 'c-FdcNestedList__value',
    title: 'c-FdcNestedList__title',
    color: 'c-FdcNestedList__color',
    colorTitle: 'c-FdcNestedList__colorTitle',
    isReadOnly: 'FdcNestedList--is-read-only',
    isReadWrite: 'FdcNestedList--is-read-write',
    isSelected: 'FdcNestedList--is-selected',
    isSelectable: 'FdcNestedList--is-selectable',
};
const colorPickerSize = 32;
const colorPickerMargin = 20;
const inputWidth = 248;
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        display: 'flex',
    },
    [exports.CSS.list]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.column), { width: '100%', 'max-width': '340px' }),
    [exports.CSS.title]: {
        display: 'flex',
        alignItems: 'center',
        height: '20px',
        'text-align': 'left',
        'margin-bottom': theme_1.DefaultTheme.space(4),
        '& .mdl-textfield': {
            width: `${inputWidth}px`,
        },
        '& input': {
            'font-weight': theme_1.DefaultTheme.font.weight.bold,
        },
    },
    [exports.CSS.value]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { 'text-align': 'left', 'text-transform': 'none', height: '36px', '& input': {
            outline: 'none',
        }, '& button': {
            width: '300px',
        }, '& .mdl-textfield': {
            width: `${inputWidth}px`,
        } }),
    [exports.CSS.isSelected]: {
        color: theme_1.DefaultTheme.font.color.link,
    },
    [exports.CSS.isSelectable]: {
        cursor: 'pointer',
    },
    [exports.CSS.colorTitle]: {
        width: `${colorPickerSize}px`,
        marginRight: `${colorPickerMargin}px`,
        'font-weight': 'bold',
        color: theme_1.DefaultTheme.font.color.supporting,
        [`& + .mdl-textfield`]: {
            width: `${300 - colorPickerSize - colorPickerMargin}px`,
        },
    },
    [exports.CSS.color]: {
        width: `${colorPickerSize}px`,
        height: '20px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderRadius: '4px',
        border: '2px solid #c9c9c9',
        marginRight: `${colorPickerMargin}px`,
        ['& input[type=color]']: {
            width: 'calc(100% + 12px)',
            height: 'calc(100% + 12px)',
            padding: 0,
            margin: '-6px',
            cursor: 'pointer',
        },
        [`& + .${exports.CSS.value} > .mdl-textfield`]: {
            width: `calc(300px - ${colorPickerSize + colorPickerMargin}px)`,
        },
    },
});
/** Maximum number of levels to support. Too many becomes difficult to edit and visualize. */
const MAX_OPTIONS = 3;
class FormFieldEditorNestedList extends form_field_editor_1.FormFieldEditor {
    constructor(designer, field) {
        super(designer, field);
        this.selected = mobx_1.observable.array();
        this.stateGroups = [];
        this.isAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        // Init the selected to the first option every level
        this.builder = field.Mutator.builder;
        const options = this.builder.options;
        if (options != null && Array.isArray(options.values) && options.values.length > 0) {
            this.setSelected(0, 0);
        }
        if (options == null) {
            this.builder.createGroup(this.getOptionTitle(0));
        }
    }
    viewInfoRW() {
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.viewNestedOptionsRW(this.field.options));
    }
    viewInfoRO() {
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.viewNestedOptionsRO(this.field.options));
    }
    getCurrentOption(path) {
        let opts = this.field.options;
        for (const pathIndex of path) {
            if (opts == null || opts.values == null || pathIndex >= opts.values.length) {
                return null;
            }
            opts = opts.values[pathIndex].options;
        }
        if (opts == null || opts.values == null) {
            return null;
        }
        return opts;
    }
    getCurrentValue(path, offset) {
        const opts = this.getCurrentOption(path);
        if (opts == null) {
            return null;
        }
        return opts.values[offset];
    }
    getCurrentValueString(path, offset, type) {
        const node = this.getCurrentValue(path, offset);
        if (node == null) {
            return '';
        }
        if (type === input_state_1.InputStateTypes.COLOR) {
            return node.color;
        }
        return node.value;
    }
    destroyStateGroup(index) {
        // If no change is required, avoid touching the array and causing a reaction.
        if (index >= this.stateGroups.length) {
            return;
        }
        for (let i = index; i < this.stateGroups.length; i++) {
            this.stateGroups[i].destroy();
        }
        this.stateGroups = this.stateGroups.slice(0, index);
    }
    getStateGroup(index) {
        let existing = this.stateGroups[index];
        if (existing == null) {
            existing = this.stateGroups[index] = new input_state_group_1.IkeInputStateGroup();
            this.state.add(existing);
        }
        return existing;
    }
    getColorState(index, offset) {
        const path = this.selected.slice(0, index);
        const currentSelection = path.join('__');
        const fieldKey = `${currentSelection}:${offset}:color`;
        const state = this.getStateGroup(index);
        let editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.COLOR);
            state.add(editState);
            editState.onValue((value) => {
                const group = this.builder.getGroup(path);
                if (group == null) {
                    const groupTitle = this.getOptionTitle(index);
                    this.builder.getValue(path).createGroup(groupTitle).createValue(value);
                }
                else if (offset < group.size) {
                    group.getValue(offset).setColor(value);
                }
                else {
                    group.createValue(value);
                }
                this.applyChanges();
            });
            editState.setValue(this.getCurrentValueString(path, offset, input_state_1.InputStateTypes.COLOR) || '#a0aec0');
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_VALUE));
            editState.reaction(() => editState.focused, (focused) => focused && this.setSelected(index, offset));
        }
        editState.isRequired = this.isExistingOption(path, offset);
        return editState;
    }
    getValueState(index, offset) {
        const path = this.selected.slice(0, index);
        const currentSelection = path.join('__');
        const fieldKey = `${currentSelection}:${offset}`;
        const state = this.getStateGroup(index);
        let editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.TEXT);
            state.add(editState);
            editState.onValue((value) => {
                const group = this.builder.getGroup(path);
                if (group == null) {
                    const groupTitle = this.getOptionTitle(index);
                    this.builder.getValue(path).createGroup(groupTitle).createValue(value);
                }
                else if (offset < group.size) {
                    group.getValue(offset).setValue(value);
                }
                else {
                    group.createValue(value);
                }
                this.applyChanges();
            });
            editState.setValue(this.getCurrentValueString(path, offset));
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_VALUE));
            editState.reaction(() => editState.focused, (focused) => focused && this.setSelected(index, offset));
        }
        editState.isRequired = this.isExistingOption(path, offset);
        return editState;
    }
    isExistingOption(path, offset) {
        const opts = this.getCurrentOption(path);
        // This is a placeholder option for a new group and not required.
        if (opts == null) {
            return false;
        }
        // This is a placeholder option for an empty group and is required.
        if (opts.values.length === 0) {
            return true;
        }
        // This is a placeholder option for a non-empty group and is not required.
        if (offset >= opts.values.length) {
            return false;
        }
        // All other options are required.
        return true;
    }
    getOptionTitleState(index) {
        const path = this.selected.slice(0, index);
        const currentSelection = path.join('__');
        const fieldKey = `${currentSelection}:title`;
        const state = this.getStateGroup(index);
        const level = index + 1;
        let editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.TEXT);
            state.add(editState);
            editState.isRequired = true;
            editState.onValue((value) => {
                const group = this.builder.getGroup(path);
                if (group != null) {
                    group.setTitle(value);
                }
                else {
                    this.builder.getValue(path).createGroup(value);
                }
                this.applyChanges();
            });
            const opt = this.getCurrentOption(path);
            if (opt != null && opt.title != null && opt.title.length > 0) {
                editState.setValue(opt.title);
            }
            else {
                editState.setValue((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_TITLE, { level }));
            }
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_TITLE, { level }));
        }
        return editState;
    }
    getOptionTitle(index) {
        return this.getOptionTitleState(index).value;
    }
    confirmDeleteValue(index, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Don't ask if there are no nested options
            const path = [...this.selected.slice(0, index), offset];
            if (this.builder.getGroup(path) == null) {
                this.deleteValue(index, offset);
                return;
            }
            const result = yield modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE_TITLE),
                content: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE_CONFIRM),
                hasCancel: true,
                okName: i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE,
            });
            if (result.ok) {
                this.deleteValue(index, offset);
            }
        });
    }
    deleteValue(index, offset) {
        const path = this.selected.slice(0, index);
        this.builder.getGroup(path).deleteValue(offset);
        if (this.builder.getGroup(path).size === 0) {
            const prevPath = path.slice(0, path.length - 1);
            if (prevPath.length > 0) {
                const newIndex = path[path.length - 1];
                const oldValue = this.builder.getGroup(prevPath).getValue(newIndex);
                this.builder.getGroup(prevPath).deleteValue(newIndex);
                this.builder.getGroup(prevPath).createValue(oldValue.value, null, oldValue.color, newIndex);
            }
        }
        this.applyChanges();
        this.destroyStateGroup(index);
        this.setSelected(index, Math.max(0, offset - 1));
    }
    viewNestedOptionButton(value, isSelected, index, offset) {
        let className = `mdl-button ${exports.CSS.value} ${exports.CSS.isReadOnly}`;
        if (isSelected) {
            className += ' ' + exports.CSS.isSelected;
        }
        else {
            className += ' ' + exports.CSS.isSelectable;
        }
        return (0, mithril_1.m)('button', {
            className,
            onclick: isSelected ? null : () => this.setSelected(index, offset),
        }, value);
    }
    viewNestedOptionsRW(opt) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const editor = this;
        function makeNode(child, index, offset, isSelected) {
            let className = `${exports.CSS.value}`;
            if (isSelected) {
                className += ' ' + exports.CSS.isSelected;
            }
            const showColor = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && editor.field.isMapColorField && index === 0;
            const children = [];
            if (editor.field.isLocked && !editor.isAnalyst) {
                children.push(editor.viewNestedOptionButton(child.value, isSelected, index, offset));
            }
            else {
                if (showColor) {
                    children.push((0, mithril_1.m)('div', { className: exports.CSS.color }, input_1.Input.view(editor.getColorState(index, offset), { rawInputOnly: true })));
                }
                children.push((0, mithril_1.m)('div', { className }, input_1.Input.view(editor.getValueState(index, offset))));
            }
            if (isSelected) {
                children.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, { onclick: () => editor.confirmDeleteValue(index, offset) }));
            }
            return (0, mithril_1.m)('div', { className }, children);
        }
        return this.viewNestedOptions(opt, makeNode);
    }
    viewNestedOptionsRO(opt) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const editor = this;
        function makeNode(child, index, offset, isSelected) {
            return editor.viewNestedOptionButton(child.value, isSelected, index, offset);
        }
        return this.viewNestedOptions(opt, makeNode);
    }
    viewNestedOptions(opt, nodeMaker, index = 0) {
        if (opt == null) {
            if (index > this.selected.length || index >= MAX_OPTIONS) {
                return [];
            }
            opt = { title: '', values: [] };
        }
        const children = [this.viewOptionTitle(opt, index)];
        let levels = [];
        for (let offset = 0; offset < opt.values.length; offset++) {
            const child = opt.values[offset];
            const isSelected = this.selected.length > index && offset === this.selected[index];
            let node;
            if (isSelected) {
                levels = this.viewNestedOptions(child.options, nodeMaker, index + 1);
                node = nodeMaker(child, index, offset, isSelected);
            }
            else {
                node = nodeMaker(child, index, offset, isSelected);
            }
            children.push(node);
        }
        if (!(this.field.isLocked && !this.isAnalyst) && this.designer.isEditing) {
            children.push(nodeMaker({ value: '' }, index, opt.values.length, false));
        }
        return [(0, mithril_1.m)('div', { className: exports.CSS.list }, children), ...levels];
    }
    viewOptionTitle(opt, index) {
        const children = [];
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField && index === 0) {
            children.push((0, mithril_1.m)('div', { className: exports.CSS.colorTitle }, (0, i18n_1.Translate)(i18n_1.T.COLOR)));
        }
        if (!this.field.isLocked && this.designer.isEditing) {
            const inputState = this.getOptionTitleState(index);
            children.push(input_1.Input.view(inputState));
            return (0, mithril_1.m)('div', { className: exports.CSS.title }, children);
        }
        children.push(opt.title);
        return (0, mithril_1.m)('div', { className: exports.CSS.title }, children);
    }
    setSelected(index, offset) {
        if (this.selected.length > index && this.selected[index] === offset) {
            return;
        }
        this.destroyStateGroup(index);
        if (this.selected.length > index) {
            this.selected.splice(index);
        }
        this.selected.push(offset);
        // Set the selected to the first value down the nest
        const nestedValue = this.getCurrentValue(this.selected.slice(), offset);
        if (nestedValue == null) {
            return;
        }
        let opt = nestedValue.options;
        while (opt != null && Array.isArray(opt.values)) {
            const current = opt.values[0];
            if (current == null) {
                break;
            }
            this.selected.push(0);
            opt = current.options;
        }
    }
    applyChanges() {
        this.field.Mutator.init(this.builder.options);
    }
}
exports.FormFieldEditorNestedList = FormFieldEditorNestedList;
tslib_1.__decorate([
    mobx_1.action
], FormFieldEditorNestedList.prototype, "deleteValue", null);
tslib_1.__decorate([
    mobx_1.action
], FormFieldEditorNestedList.prototype, "setSelected", null);
//# sourceMappingURL=form.field.editor.nested.list.js.map